var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-js-responsive-containerx vjs-hdx video-border vjs-16-9"},[_c('video',{ref:"videoPlayer",staticClass:"video-js",attrs:{"autoplay":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }